import { useState } from "react";
import { Spinner } from "reactstrap";
const MediaImage = ({ img, isSelected, handleSelect, renderDeleteIcon }) => {
  const [loaded, setLoaded] = useState(false);

  return (
    <div
      key={img.id}
      style={{
        position: "relative",
        width: "100%",
        height: 150,
        cursor: "pointer",
        overflow: "hidden",
        borderRadius: 8,
        background: "#f0f0f0",
      }}
    >
      <input
        type="checkbox"
        checked={isSelected(img.url)}
        onChange={() => handleSelect(img)}
        style={{
          position: "absolute",
          top: 8,
          left: 8,
          zIndex: 2,
        }}
      />
      {renderDeleteIcon(img.id)}

      {!loaded && (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{
            position: "absolute",
            inset: 0,
            background: "#f8f9fa",
          }}
        >
          <Spinner size="sm" color="primary" />
        </div>
      )}

      <img
        src={img.url}
        alt="media"
        loading="lazy"
        onLoad={() => setLoaded(true)}
        onError={(e) => {
          e.target.src = "/default-placeholder.png";
          //   setLoaded(true);
        }}
        onClick={() => window.open(img.url, "_blank")}
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          border: isSelected(img.url) ? "3px solid #007bff" : "1px solid #ddd",
          borderRadius: 8,
        }}
      />
    </div>
  );
};

export default MediaImage;
